module.exports = __webpack_public_path__ + "img/icon-categoria2.bb43760e.png";